import type { ConceptDef } from '../types';

export const sortByColor: ConceptDef = {
  kind: 'tileMatch',
  id: 'sort-by-color',
  label: 'Sort by Color',
  category: 'Sorting',
  description: 'Hear a color group; tap an item of that color.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'something red', answer: '🍎 apple' },
      { say: 'something yellow', answer: '🌞 sun' },
      { say: 'something blue', answer: '🌊 ocean' },
      { say: 'something green', answer: '🌳 tree' },
      { say: 'something orange', answer: '🥕 carrot' },
      { say: 'something purple', answer: '🍇 grapes' },
    ],
  },
};
